/* istanbul ignore file */
export { default } from './Notification';
